import React from "react";
import Card from "@mui/material/Card";
import useSales from "./useSales";
import {NavLink} from "react-router-dom";
import MDBox from "../../../../../components/MDBox";
import DataTable from "../../../../../components/DataTable/DataTable";
import {API_URL, COLOR_SECONDARY} from "../../../../../config";
import moment from "moment";
import DateFilter from "../../../../../components/DateFilter/DateFilter";
import {renderCurrency} from "../../../../../helpers/helpers";

const Sales = ({id}) => {
    const {actions, renderStatusChip } = useSales();

    return (
            <MDBox mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                <MDBox mb={3}>
                        <DataTable
                            endpoint={`${API_URL}/sales/doctor/${id}`}
                            title="Ventas"
                            description="Ventas asociadas al perfil."
                            sortBy="id"
                            sortDirection="desc"
                            filter={true}
                            actions={actions}
                            colData={[
                                {
                                    name: 'id',
                                    label: 'Folio',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <NavLink to={`/ventas/${tableMeta.rowData[0]}`}
                                                     key={`venta-${tableMeta.rowData[0]}`}
                                                     style={{fontWeight: 500, color: COLOR_SECONDARY, textDecoration: 'underline'}}
                                            >
                                                #Tck-{value}
                                            </NavLink>
                                        )
                                    }
                                },
                                {
                                    name: 'patient.name',
                                    label: 'Paciente',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <div>
                                                {value} {tableMeta.rowData[2]} {tableMeta.rowData[3]}
                                            </div>
                                        )
                                    }
                                },
                                {
                                    name: 'patient.last_name',
                                    label: 'Apellido Paterno',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'patient.mother_last_name',
                                    label: 'Apellido Materno',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'location.display_name',
                                    label: 'Sucursal'
                                },
                                {
                                    name: 'doctor_fee',
                                    label: 'Comisión Doctor',
                                    options: {
                                        customBodyRender: renderCurrency,
                                        filter: false
                                    }
                                },
                                {
                                    name: 'total',
                                    label: 'Total',
                                    options: {
                                        customBodyRender: renderCurrency,
                                        filter: false
                                    }
                                },
                                {
                                    name: 'status',
                                    label: 'Estado',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => {
                                            return renderStatusChip(value)
                                        }
                                    }
                                },
                                {
                                    name: 'created_at',
                                    label: 'Fecha',
                                    options: {
                                        filterType: 'custom',
                                        customFilterListOptions: {
                                            render: v => {
                                                if (v[0] && v[1]) return `Fecha: ${moment(v[0]).format('YYYY-MM-DD')} - ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                if (v[0]) return `Desde: ${moment(v[0]).format('YYYY-MM-DD')}`;
                                                if (v[1]) return `Hasta: ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                return false;
                                            },
                                            update: (filterList, filterPos, index) => {
                                                if (filterPos === 0) filterList[index].splice(filterPos, 1, '');
                                                else filterList[index] = [];
                                                return filterList;
                                            }
                                        },
                                        filterOptions: {
                                            names: [],
                                            display: (filterList, onChange, index, column) => <DateFilter filterList={filterList} column={column} onChange={onChange} index={index} />
                                        }
                                    }
                                },
                            ]}
                        />
                </MDBox>
            </MDBox>
    );
};

export default Sales;
